export default __webpack_public_path__ + "static/media/32.6990f0e3.png";